import { gql } from '@apollo/client'

export const userHashtagRemoveById = gql`
  mutation UserHashtagRemoveById($_id: String!) {
    userHashtagRemoveById(_id: $_id)
  }
`
